import React from 'react';
import { Header } from './header';
import { Footer } from './footer';
import ScrollToTop from '../../../components/scroll-to-top';

import '../styles/index.css';

export const V2Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <ScrollToTop />
    </>
  );
};
